import type { ReactNode } from "react";
import Sidebar from "../Sidebar/Sidebar";
import ErrorBoundary from "@src/presentation/components/common/ErrorBoundary";
import { SidebarProvider } from "@src/presentation/providers/SidebarProvider";

/**
 * Layout Component - Presentation layer
 * Single Responsibility: Provides consistent layout structure
 */
interface LayoutProps {
  children: ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  return (
    <ErrorBoundary>
      <SidebarProvider>
        <div className="main-container">
          <Sidebar />
          <main className="main-content compact-ui">{children}</main>
        </div>
      </SidebarProvider>
    </ErrorBoundary>
  );
};
